"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackReportError = trackReportError;
const browser_core_1 = require("@datadog/browser-core");
function trackReportError(configuration, errorObservable) {
    const subscription = (0, browser_core_1.initReportObservable)(configuration, [
        browser_core_1.RawReportType.cspViolation,
        browser_core_1.RawReportType.intervention,
    ]).subscribe((rawError) => errorObservable.notify(rawError));
    return {
        stop: () => {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map